import { render, staticRenderFns } from "./showArchiveType.vue?vue&type=template&id=a03c2cf4&scoped=true&"
import script from "./showArchiveType.vue?vue&type=script&lang=js&"
export * from "./showArchiveType.vue?vue&type=script&lang=js&"
import style0 from "./showArchiveType.vue?vue&type=style&index=0&id=a03c2cf4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a03c2cf4",
  null
  
)

export default component.exports